import axios from 'axios';
import { configs } from '../app/app-configs';
import { StaffAttendance, StaffAttendanceRequest, StaffAttendanceSearchCriteria } from './model/staff-attendance.model';
import { PaginatedResponse } from './model/paginated-response';

export const getStaffAttendancePage = async (
    search: StaffAttendanceSearchCriteria,
): Promise<PaginatedResponse<StaffAttendance>> => {
    return await axios
        .get(`${configs.BASE_URL}/staff-attendance?page=${search.pagination.page ?? 0}&size=${search.pagination.size ?? configs.PAGE_SIZE}&from=${search.from}&to=${search.to}&name=${search.name}`)
        .then((res) => {
            return res.data as PaginatedResponse<StaffAttendance>;
        });
};

export const getMyAttendance = async (
    search: StaffAttendanceSearchCriteria,
): Promise<PaginatedResponse<StaffAttendance>> => {
    return await axios
        .get(`${configs.BASE_URL}/staff-attendance/me?page=${search.pagination.page ?? 0}&size=${search.pagination.size ?? configs.PAGE_SIZE}&from=${search.from}&to=${search.to}`)
        .then((res) => {
            return res.data as PaginatedResponse<StaffAttendance>;
        });
};

export const createStaffAttendance = async (
    request: StaffAttendanceRequest,
): Promise<StaffAttendance> => {
    return await axios
        .post(`${configs.BASE_URL}/staff-attendance`, request)
        .then((res) => {
            return res.data as StaffAttendance;
        });
};

export const updateStaffAttendance = async (
    request: StaffAttendanceRequest,
): Promise<StaffAttendance> => {
    return await axios
        .put(`${configs.BASE_URL}/staff-attendance/${request.id}`, request)
        .then((res) => {
            return res.data as StaffAttendance;
        });
};

export const deleteStaffAttendance = async (id: number): Promise<number> => {
    return await axios
        .delete(`${configs.BASE_URL}/staff-attendance/${id}`)
        .then((res) => {
            return res.data;
        });
};

export const getStaffAttendanceSummary = async (): Promise<any> => {
    return await axios
        .get(`${configs.BASE_URL}/staff-attendance/summary`)
        .then((res) => {
            return res.data;
        });
};
